var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.50001V3.50001C21.4644 3.50001 21.6966 3.50001 21.8916 3.52568C23.2378 3.7029 24.2971 4.76223 24.4743 6.10843C24.5 6.30338 24.5 6.53559 24.5 7.00001L24.5 9.5C24.5 9.9714 24.5 10.2071 24.3536 10.3536C24.3536 10.3536 24.3536 10.3536 24.3536 10.3536C24.2071 10.5 23.9714 10.5 23.5 10.5L17.5 10.5M21 3.50001V3.50001C20.5356 3.50001 20.3034 3.50001 20.1084 3.52568C18.7622 3.70291 17.7029 4.76223 17.5257 6.10843C17.5 6.30338 17.5 6.53559 17.5 7.00001L17.5 10.5M21 3.50001L7.5 3.50001C5.61438 3.50001 4.67157 3.50001 4.08579 4.0858C3.5 4.67158 3.5 5.61439 3.5 7.50001L3.5 24.5L7 23.3333L10.5 24.5L14 23.3333L17.5 24.5L17.5 10.5",
    stroke: "#657B90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16666 8.16666L12.8333 8.16666",
    stroke: "#657B90",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 12.8333H8.16667",
    stroke: "#657B90",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16666 17.5L11.6667 17.5",
    stroke: "#657B90",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperLight);
export default __webpack_public_path__ + "static/media/Paper_light.327be4c4db22f690762c83a9255249bd.svg";
export { ForwardRef as ReactComponent };